import { render, staticRenderFns } from "./AuthTest.vue?vue&type=template&id=e70a586e&scoped=true&"
import script from "./AuthTest.vue?vue&type=script&lang=js&"
export * from "./AuthTest.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e70a586e",
  null
  
)

export default component.exports